export default __webpack_public_path__ + "images/fulltime-icon-b91469.svg";